import type { GetNotifications200NotificationsItemSourceSourceUser } from './getNotifications200NotificationsItemSourceSourceUser';

export type GetNotifications200NotificationsItemSource = {
  sourceUser?: GetNotifications200NotificationsItemSourceSourceUser;
  /** @nullable */
  sourceUserId?: number | null;
};
